import { getCurrentQuery } from './window';

export function importCSSFromUrl(): void {
  const urlParams = new URLSearchParams(getCurrentQuery());
  const cssUrl = urlParams.get('css');
  if (cssUrl) {
    const head = document.querySelector('head');
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';

    head?.appendChild(link);
    link.href = cssUrl;
  }
}
